<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p style="text-align: center;">
<br/>
	Diversion Books<br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1004<br/>
	New York, New York 10016<br/>
<a href="https://www.diversionbooks.com/" target="_blank">www.DiversionBooks.com</a></p>
<p style="text-align: center;">
<br/>
<br/>
	Copyright © 2012 by The Washington Post</p>
<p style="text-align: center;">
</p>
<p style="text-align: center;">
	Cover designed by David Griffin</p>
<p style="text-align: center;">
	Cover image courtesy of HARRY NALTCHAYAN/TWP</p>
<p style="text-align: center;">
<br/>
	All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p style="text-align: center;">
<br/>
	For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a>.</p>
<p style="text-align: center;">
<br/>
	First Diversion Books edition September 2012.</p>
<p style="text-align: center;">
</p>
<p style="text-align: center;">
	ISBN: 978-1-938120-58-9 (ebook)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap71682.vue?72b60b35